import _implicitStylesheets from "./supportDetails.css";
import _implicitScopedStylesheets from "./supportDetails.scoped.css?scoped=true";
import _adsImage from "ads/image";
import _wdsLink from "wds/link";
import _wdsButton from "wds/button";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-7"${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<h3 type-style="display-7" class="publisher-name${0}"${2}>${"t1"}</h3>`;
const $fragment3 = parseFragment`<p type-style="display-8" class="publisher-location${0}"${2}>${"t1"}</p>`;
const $fragment4 = parseFragment`<p type-style="body-3" class="publisher-description${0}"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<div class="flex-section${0}"${2}><span type-style="body-3" class="bolded${0}"${2}>${"t2"}</span><span type-style="body-3"${3}>${"t4"}</span></div>`;
const $fragment6 = parseFragment`<span type-style="body-3" class="bolded${0}"${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<a${"a0:href"} target="_blank" type-style="body-3" class="link${0}"${2}>${"t1"}</a>`;
const $fragment8 = parseFragment`<a${"a0:href"} target="_blank" type-style="body-3" class="link${0}"${2}>${"t1"}</a>`;
const $fragment9 = parseFragment`<a href="javascript:;" type-style="body-3" class="terms-and-conditions-link link${0}" data-testid="t&amp;c-link"${2}>${"t1"}</a>`;
const $fragment10 = parseFragment`<a${"a0:href"} target="_blank" type-style="body-1" class="link tos-link${0}"${2}>${"t1"}</a>`;
const $fragment11 = parseFragment`<h3 type-style="body-1"${3}>${"t1"}</h3>`;
const $fragment12 = parseFragment`<p${3}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "publisher-head-container": true
  },
  key: 2
};
const stc1 = {
  classMap: {
    "logo-container": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "flex-section": true,
    "links": true
  },
  key: 13
};
const stc3 = {
  key: 16
};
const stc4 = {
  key: 19
};
const stc5 = {
  key: 22
};
const stc6 = {
  slotAssignment: "main-content",
  key: 26
};
const stc7 = {
  key: 27
};
const stc8 = {
  slotAssignment: "footer",
  key: 34
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.labels.needHelp))]), api_element("div", stc0, [api_element("div", stc1, [api_custom_element("ads-image", _adsImage, {
    props: {
      "src": $cmp.logo,
      "alt": $cmp.logoAlt,
      "fallback": "circle",
      "variant": "basic",
      "width": "40px",
      "height": "40px",
      "loadingBorder": "false"
    },
    key: 4
  })]), api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.publisherName))])]), api_static_fragment($fragment3, 8, [api_static_part(1, null, api_dynamic_text($cmp.publisherLocation))]), api_static_fragment($fragment4, 10, [api_static_part(1, null, api_dynamic_text($cmp.supportDetails))]), $cmp.supportPhoneNumber ? api_static_fragment($fragment5, 12, [api_static_part(2, null, api_dynamic_text($cmp.labels.supportPhone)), api_static_part(4, null, api_dynamic_text($cmp.supportPhoneNumber))]) : null, api_element("div", stc2, [api_static_fragment($fragment6, 15, [api_static_part(1, null, api_dynamic_text($cmp.labels.otherResources))]), $cmp.mailTo ? api_custom_element("wds-link", _wdsLink, stc3, [api_static_fragment($fragment7, 18, [api_static_part(0, {
    attrs: {
      "href": $cmp.mailTo
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.email))])]) : null, $cmp.supportKnowledgeBaseURL ? api_custom_element("wds-link", _wdsLink, stc4, [api_static_fragment($fragment8, 21, [api_static_part(0, {
    attrs: {
      "href": $cmp.supportKnowledgeBaseURL
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.knowledgeBase))])]) : null, api_custom_element("wds-link", _wdsLink, stc5, [api_static_fragment($fragment9, 24, [api_static_part(0, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.openTermsAndConditions))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.termsAndConditions))])])]), $cmp.displayTermsAndConditions ? api_custom_element("wds-modal", _wdsModal, {
    props: {
      "title": $cmp.termsAndConditionsModalLabels.title,
      "closedFocusTarget": $cmp.termsAndConditionsLinkRef
    },
    key: 25,
    on: {
      "close": _m2 || ($ctx._m2 = api_bind($cmp.closeTermsAndConditions))
    }
  }, [api_element("div", stc6, [api_custom_element("wds-link", _wdsLink, stc7, [api_static_fragment($fragment10, 29, [api_static_part(0, {
    attrs: {
      "href": $cmp.termsAndConditionsModalLabels.termsOfServiceLink
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.termsAndConditionsModalLabels.termsOfServiceLinkLabel))])]), api_static_fragment($fragment11, 31, [api_static_part(1, null, api_dynamic_text($cmp.termsAndConditionsModalLabels.appTermsAndConditions))]), api_static_fragment($fragment12, 33, [api_static_part(1, null, api_dynamic_text($cmp.termsAndConditions))])]), api_element("div", stc8, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "label": $cmp.termsAndConditionsModalLabels.gotIt
    },
    key: 35,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.closeTermsAndConditions))
    }
  })])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2v5m81tsr0s";
tmpl.legacyStylesheetToken = "undefined-_supportDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
